import React from "react";
import notFoundImg from "../../assets/not-found-img.svg";
import ShadowBox from "../../components/ShadowBox";
import { LocalisedText } from "../../i18n";
import styles from "./style.module.scss";

const NotFoundScreen: React.FC = () => {
  return (
    <div className={styles.wrapper}>
      <ShadowBox>
        <img className={styles.notFoundImg} alt="Not found" src={notFoundImg} />
        <p className={styles.title}>
          <LocalisedText id="screen.notFoundScreen.title.text" />
        </p>
        <p className={styles.message}>
          <LocalisedText id="screen.notFoundScreen.message.text" />
        </p>
      </ShadowBox>
    </div>
  );
};

export default NotFoundScreen;
